import React from "react";

import { DeleteButton, OutlinedButton } from "@/Components/v2/atoms/Button";

import { Confirmation } from "./Confirmation";

export interface DeleteConfirmationProps {
  open: boolean;
  title: string;
  subtitle: string;
  onDelete: () => void;
  onCancel: () => void;
  deleteButtonText?: string;
  cancelButtonText?: string;
}

export const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  open,
  title,
  subtitle,
  onDelete,
  onCancel,
  deleteButtonText = "Delete",
  cancelButtonText = "Cancel",
}) => {
  return (
    <Confirmation
      open={open}
      title={title}
      subtitle={subtitle}
      primaryButtonText={deleteButtonText}
      secondaryButtonText={cancelButtonText}
      onPrimary={onDelete}
      onSecondary={onCancel}
      renderPrimaryButton={({ onClick, children }) => (
        <DeleteButton size="large" onClick={onClick}>
          {children}
        </DeleteButton>
      )}
      renderSecondaryButton={({ onClick, children }) => (
        <OutlinedButton variant="text" size="large" onClick={onClick}>
          {children}
        </OutlinedButton>
      )}
    />
  );
};

export default DeleteConfirmation;
